import React, { useEffect, useState } from 'react';
import axios from 'axios';
import jsSHA from 'jssha';
import './style.css'; 

// Hash the subscription object
function hashSubscription(subscription) {
  const shaObj = new jsSHA('SHA-256', 'TEXT', { encoding: 'UTF8' });
  shaObj.update(JSON.stringify(subscription));
  return shaObj.getHash('HEX');
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function PushComponent() {
  const [convertedVapidKey, setConvertedVapidKey] = useState(null);
  const [pushSubscription, setPushSubscription] = useState(null);
  const [retryCount, setRetryCount] = useState(0);
  const [unsubscriptionSuccess, setUnsubscriptionSuccess] = useState(false);
  const [subscriptionSuccess, setSubscriptionSuccess] = useState(false); // Added this line

  // A utility function to retry an async function
  async function retryAsync(fn, retries = 3, interval = 1000) {
    for (let attempt = 1; attempt <= retries; attempt++) {
      try {
        return await fn();
      } catch (err) {
        if (attempt === retries) throw err;
        await new Promise(resolve => setTimeout(resolve, interval));
      }
    }
  }

  async function subscribeUser() {
    if ('serviceWorker' in navigator) {
      const registration = await navigator.serviceWorker.ready;
      if (!registration.pushManager) {
        console.log('Push manager unavailable.');
        return;
      }

      try {
        // Fetch the public VAPID key from the server
        const fetchVapidKey = async () => {
          const response = await axios.get('/api/vapid-public-key');
          return urlBase64ToUint8Array(response.data);
        };

        const convertedVapidKey = await retryAsync(fetchVapidKey);

        // Proceed with subscribing
        const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: convertedVapidKey,
        });

        console.log('Subscribed!');

        const postSubscription = async () => {
          await axios.post('/api/push-subscriptions', subscription);
        };
        await retryAsync(postSubscription);

        setRetryCount(0);  // Reset the retry count
        setSubscriptionSuccess(true); 
        setPushSubscription(subscription);

        const subscriptionHash = hashSubscription(subscription);
        localStorage.setItem('subscriptionHash', subscriptionHash);

      } catch (err) {
        //console.error('Error during subscription process:', err);
        // Handle errors, retry logic, etc.
      }
    }
  }

  async function unsubscribeUser() {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();

    if (subscription) {
      const successful = await subscription.unsubscribe();
      if (successful) {
        try {
          const subscriptionHash = localStorage.getItem('subscriptionHash');
          if (subscriptionHash) {
            const deleteSubscription = async () => {
              return await axios.delete('/api/push-subscriptions', {
                params: { subscriptionHash },
              });
            };

            await retryAsync(deleteSubscription);

            setUnsubscriptionSuccess(true);
            localStorage.removeItem('subscriptionHash'); // Remove the hash from local storage
          } else {
            //console.error('No subscription hash found in local storage');
          }
          setPushSubscription(null);
        } catch (err) {
          //console.error('Error during unsubscription:', err);
          // Handle errors here
        }
      }
    }
  }

  useEffect(() => {
    (async () => {
      if ('serviceWorker' in navigator) {
        // Retrieve the hash from local storage
        const subscriptionHash = localStorage.getItem('subscriptionHash');

        if (subscriptionHash) {
          try {
            // Define a function to check subscription status
            const checkSubscription = async () => {
              return await axios.get('/api/check-push-subscriptions', {
                params: { subscriptionHash },
              });
            };

            // Check subscription status with the server with retries
            const serverResponse = await retryAsync(checkSubscription);
            //console.log('Server subscription status:', serverResponse.data.isSubscribed ? 'Subscribed' : 'Not Subscribed');

            // Set subscription status based on server response
            setPushSubscription(serverResponse.data.isSubscribed ? serverResponse.data.subscription : null);
          } catch (err) {
            //console.error('Error checking subscription status:', err);
          }
        } else {
          // No subscription hash in local storage
          //console.log('No subscription hash found in local storage');
          setPushSubscription(null);
        }
      }
    })();
  }, []);

  return (
    <div>
       {!pushSubscription ? (
        <button 
          onClick={subscribeUser} 
           
          className="w-full md:w-40 mt-8 px-4 py-4 font-semibold rounded border border-gray-600 text-gray-600 hover:bg-gray-600 hover:text-white transition-colors duration-200"
        >
          SUBSCRIBE TO PUSH NOTIFICATION
        </button>
        
      ) : (
        <button 
          onClick={unsubscribeUser} 
         
          className="w-full md:w-40 mt-8 px-4 py-2 font-semibold rounded border border-gray-600 text-gray-600 hover:bg-gray-600 hover:text-white transition-colors duration-200"
        >
          UNSUBSCRIBE FROM PUSH NOTIFICATIONS
        </button>
      )}
      {subscriptionSuccess && (
        <p className="error-message">You have successfully subscribed to notifications!</p>
      )}
      {unsubscriptionSuccess && (
        <p className="error-message">You have successfully unsubscribed from notifications!</p>
      )}
      
    </div>
  );
}
